module.exports = __webpack_public_path__ + "static/media/bg-congratulation-b.071e2924.png";